import { render, staticRenderFns } from "./RefreshDeveloperClientSecretModal.vue?vue&type=template&id=10310e97&lang=pug"
import script from "./RefreshDeveloperClientSecretModal.vue?vue&type=script&lang=js"
export * from "./RefreshDeveloperClientSecretModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports